import React from 'react';
import LegalPage, { Section } from './LegalPage';

export default function TermsPage() {
  return (
    <LegalPage
      title="Termini e Condizioni del Servizio"
      subtitle="Condizioni generali per i servizi di consulenza e psicoterapia erogati dal Dr. Michele Balducci."
      lastUpdate="21 giugno 2026"
    >
      <p className="bg-sageLight/40 border-l-4 border-forest p-4 rounded-r-lg">
        Prenotando un colloquio tramite il sito o accedendo ai servizi del Dr. Michele Balducci, l'utente
        dichiara di aver letto, compreso e accettato integralmente le seguenti condizioni.
      </p>

      <Section title="1. Oggetto del servizio">
        <p>
          Il Dr. Michele Balducci, psicologo iscritto all'Ordine degli Psicologi del Lazio n. 21747,
          eroga servizi di terapia individuale, sedute di ipnosi e supervisione, esclusivamente in modalità
          online tramite videoconsulto su Google Meet (o WhatsApp Video).
        </p>
      </Section>

      <Section title="2. Modalità di prenotazione">
        <p>
          La prenotazione effettuata tramite il sito costituisce una <strong>richiesta non vincolante</strong>.
          La conferma definitiva dell'appuntamento è subordinata al riscontro del Dr. Balducci entro 12 ore
          lavorative, tramite email o telefono.
        </p>
        <p>
          Il primo contatto telefonico conoscitivo (15 minuti) è gratuito e non vincolante. Serve a valutare
          la fattibilità del percorso e l'eventuale invio ad altro professionista qualora ritenuto opportuno.
        </p>
      </Section>

      <Section title="3. Tariffe e modalità di pagamento">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Terapia individuale: € 60 per seduta di 45 minuti</li>
          <li>Seduta di ipnosi: € 80 per seduta di 45 minuti</li>
          <li>Supervisione: € 60 per seduta di 45 minuti</li>
        </ul>
        <p>
          Le tariffe possono essere aggiornate; quelle vigenti sono sempre indicate nella sezione
          "Servizi" del sito. Il pagamento avviene a fine mese tramite bonifico bancario, con rilascio
          di regolare fattura sanitaria, detraibile fiscalmente.
        </p>
      </Section>

      <Section title="4. Disdette e mancata presentazione">
        <p>
          Le disdette devono essere comunicate <strong>almeno 24 ore prima</strong> dell'appuntamento tramite telefono o email.
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Disdetta entro 24 ore prima: nessun addebito.</li>
          <li>Disdetta oltre il termine o mancata presentazione: la seduta sarà addebitata per intero.</li>
          <li>In caso di forza maggiore documentabile (malattia, imprevisti gravi), la seduta potrà essere riprogrammata senza oneri.</li>
        </ul>
      </Section>

      <Section title="5. Modalità online (videoconsulto)">
        <p>
          Il videoconsulto avviene tramite piattaforma protetta da connessione cifrata (SSL/TLS).
          L'utente è tenuto a collegarsi da un ambiente riservato, con dispositivo idoneo (microfono e videocamera funzionanti)
          e connessione stabile. La registrazione audio o video della seduta è <strong>vietata</strong>, salvo esplicito consenso scritto di entrambe le parti.
        </p>
      </Section>

      <Section title="6. Riservatezza e segreto professionale">
        <p>
          Quanto emerso durante i colloqui è tutelato dal <strong>segreto professionale</strong> (art. 11 Codice Deontologico
          degli Psicologi Italiani; art. 622 c.p.). Il segreto potrà essere derogato esclusivamente nei casi
          previsti dalla legge (es. art. 200 c.p.p.) o per evitare un pericolo grave, attuale e non altrimenti evitabile per la vita
          o l'incolumità psicofisica dell'utente o di terzi.
        </p>
      </Section>

      <Section title="7. Trattamento dei dati personali">
        <p>
          Il trattamento dei dati personali avviene in conformità al GDPR. Per i dettagli si rimanda all'apposita
          Privacy Policy, accessibile dal footer del sito.
        </p>
      </Section>

      <Section title="8. Limiti del servizio">
        <p>
          Il Dr. Balducci non eroga servizi di urgenza psichiatrica o psicologica. In caso di emergenza
          (rischio di atti autolesivi, ideazione suicidaria, scompenso acuto) l'utente è invitato a contattare
          il <strong>118</strong> o a recarsi al più vicino Pronto Soccorso.
        </p>
      </Section>

      <Section title="9. Foro competente">
        <p>
          Per qualsiasi controversia relativa all'interpretazione o esecuzione delle presenti condizioni
          è competente in via esclusiva il Foro di Roma, fatta salva la competenza inderogabile del Foro del consumatore.
        </p>
      </Section>

      <Section title="10. Modifiche">
        <p>
          Le presenti condizioni possono essere aggiornate in qualsiasi momento; la versione vigente è quella pubblicata in questa pagina,
          con indicazione della data di ultimo aggiornamento.
        </p>
      </Section>
    </LegalPage>
  );
}
